import {
  ArrowRightCircleIcon,
  CircleStackIcon,
  DocumentDuplicateIcon,
  PlusIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { useState } from "react";

import { DataSourcesDialog } from "@pages/Templates/DataSourcesDialog";
import { Tip } from "@pages/Templates/Tip";

// --- Section Action Menu ---

export function SectionActionMenu({
  onAddField,
  onDuplicate,
  onDelete,
  onDataSources,
  onCopy,
  currentDataSources,
  sectionTitle,
  fieldCount,
  reportType,
}: {
  onAddField: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
  onDataSources: (deps: string[]) => void;
  onCopy: () => void;
  currentDataSources: string[];
  sectionTitle: string;
  fieldCount: number;
  /** Report type of the template this section belongs to. Threaded
   *  through to ``DataSourcesDialog`` so the assessment-tools list
   *  scopes correctly. */
  reportType: string;
}) {
  const [dsOpen, setDsOpen] = useState(false);

  return (
    <div className="flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
      <Tip text="Edit data sources">
        <button
          onClick={(e) => {
            e.stopPropagation();
            setDsOpen(true);
          }}
          className="p-1 rounded text-text-tertiary hover:text-rio-600 hover:bg-rio-50"
        >
          <CircleStackIcon className="h-4 w-4" />
        </button>
      </Tip>
      <Tip text="Add field to section">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onAddField();
          }}
          className="p-1 rounded text-text-tertiary hover:text-text-primary hover:bg-limestone-50"
        >
          <PlusIcon className="h-4 w-4" />
        </button>
      </Tip>
      <Tip text="Duplicate section">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDuplicate();
          }}
          className="p-1 rounded text-text-tertiary hover:text-text-primary hover:bg-limestone-50"
        >
          <DocumentDuplicateIcon className="h-4 w-4" />
        </button>
      </Tip>
      <Tip text="Copy section to clipboard">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onCopy();
          }}
          className="p-1 rounded text-text-tertiary hover:text-text-primary hover:bg-limestone-50"
        >
          <ArrowRightCircleIcon className="h-4 w-4" />
        </button>
      </Tip>
      <Tip
        text={fieldCount > 0 ? `Remove all ${fieldCount} field${fieldCount !== 1 ? "s" : ""} first` : "Delete section"}
      >
        <button
          onClick={(e) => {
            e.stopPropagation();
            if (fieldCount === 0) onDelete();
          }}
          className={`p-1 rounded ${fieldCount > 0 ? "text-text-disabled cursor-not-allowed" : "text-text-tertiary hover:text-text-error-primary hover:bg-red-50"}`}
        >
          <TrashIcon className="h-4 w-4" />
        </button>
      </Tip>
      <DataSourcesDialog
        open={dsOpen}
        onClose={() => setDsOpen(false)}
        title={sectionTitle}
        current={currentDataSources}
        reportType={reportType}
        onSave={(deps) => {
          onDataSources(deps);
          setDsOpen(false);
        }}
      />
    </div>
  );
}
